/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import SearchAndFilters from 'components/SearchAndFilters/index';
import { useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Row, Col } from 'reactstrap';
import {
  filterValuesAtom,
  useOnFilterChangeResetAtoms,
} from 'views/Findings/state';

import HostTypeDropdown from './HostTypeDropDown';

const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();

  const handleFilterChange = () => {
    // some change in the config happened, lets reapply filters using spread operator
    setFilterValues({ ...filtersConfig.getActiveFilterValues() });
    resetOnFilterChangeAtoms();
  };

  return (
    <Suspense fallback={<></>}>
      {/* <ResponsiveTwoColumnLayout /> */}
      <Row className="text-left">
        {/* First column: fixed width on md+, full on xs */}
        <Col xs="12" md="3" className="text-right">
          <HostTypeDropdown />
        </Col>
        {/* Second column: auto-expanding on md+, full on xs */}
        <Col xs="12" md>
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
